import type { BaseQueryError } from '@reduxjs/toolkit/query';
import type { restEndpointBaseQuery } from '../../providers/AppStateProvider/restEndpointBaseQuery';

type RtkQueryRejection = {
  error: BaseQueryError<typeof restEndpointBaseQuery>;
  isUnhandledError: boolean;
};

/**
 * Type guard for RTK Query rejections from `queryFulfilled`.
 * Narrows `rejection.error` to the typed error from `restEndpointBaseQuery`.
 */
export function isRestEndpointRejection(rejection: unknown): rejection is RtkQueryRejection {
  const error = (rejection as RtkQueryRejection | null)?.error;
  return error?.type === 'error';
}
